export default Vue => {
  let componentId = 0
  Vue.mixin({
    beforeCreate() {
      this.$componentId = componentId.toString()
      componentId += 1
    }
  })
}
